export const PARTS = {
	root: "ww-root",
	content: "ww-content",
	header: "ww-header",
	headerTitle: "ww-header-title",
	headerActions: "ww-header-actions",
	newChat: "ww-new-chat",
	menuButton: "ww-menu-button",
	menu: "ww-menu",
	menuItem: "ww-menu-item",
	close: "ww-close",
	thread: "ww-thread",
	scrollLatest: "ww-scroll-latest",
	input: "ww-input",
	inputRow: "ww-input-row",
	textarea: "ww-textarea",
	send: "ww-send",
	stop: "ww-stop",
	attach: "ww-attach",
	footer: "ww-footer",
	disclaimer: "ww-disclaimer",
	poweredBy: "ww-powered-by",
	error: "ww-error",
	message: "ww-message",
	bubble: "ww-bubble",
	loader: "ww-loader",
	reasoning: "ww-reasoning",
	reasoningToggle: "ww-reasoning-toggle",
	reasoningSteps: "ww-reasoning-steps",
	reasoningStep: "ww-reasoning-step",
	tool: "ww-tool",
	widget: "ww-widget",
	suggestions: "ww-suggestions",
	suggestion: "ww-suggestion",
	welcome: "ww-welcome",
	welcomeTitle: "ww-welcome-title",
	welcomeSubtitle: "ww-welcome-subtitle",
	welcomeSuggestions: "ww-welcome-suggestions",
	avatar: "ww-avatar",
	dock: "ww-dock",
	dockSuggestions: "ww-dock-suggestions",
	dockCard: "ww-dock-card",
	dockField: "ww-dock-field",
	dockInput: "ww-dock-input",
	dockSend: "ww-dock-send",
	dockClose: "ww-dock-close",
	panel: "ww-panel",
	composer: "ww-composer",
	dialog: "ww-dialog",
	dialogTitle: "ww-dialog-title",
	dialogText: "ww-dialog-text",
	dialogActions: "ww-dialog-actions",
	dialogPrimary: "ww-dialog-primary",
	dialogSecondary: "ww-dialog-secondary",
	dialogClose: "ww-dialog-close",
	toast: "ww-toast",
} as const;
